import { z } from 'zod';

const BrandCodeSchema = z
  .string()
  .regex(/^[a-z][a-z0-9_]{1,15}$/, '品牌代碼格式不正確');

export const BrandUpsertSchema = z.object({
  code: BrandCodeSchema,
  label: z.string().trim().min(1, '請輸入品牌名稱').max(64),
  boStatus: z.enum(['active', 'reserved', 'disabled']),
  clientPackageRequired: z.boolean(),
  clientBundleId: z.string().optional(),
  androidApplicationId: z.string().optional(),
  notes: z.string().optional(),
  defaultVersion: z.string().optional(),
  // Nullable explicitly clears a configured default. The backend verifies that
  // a non-null ID belongs to the edited brand inside its write transaction.
  defaultMemberTierId: z.number().int().positive().nullable().optional(),
  enableRegistration: z.boolean(),
});

export type BrandFormValues = z.infer<typeof BrandUpsertSchema>;
